import { defaultFetch } from './baseApi';

export type AssetType = {
	id: number;
	code: string;
	name: string;
	historicalCost: number;
	monthlyCost: number;
	usageTimeMonths: number;
	usagePercentage: number;
	totalAccountableCost: number;
	statementMonths: number;
	statementAmount: number;
	remainingMonths: number;
	remainingAmount: number;
};

export const getAssetsOverviewByProjectId = async (projectId: string) => {
	return defaultFetch<AssetType[]>(`/v0/projects/${projectId}/projectassetsoverview`);
};

export const getAssetsByProjectId = async (projectId: string) => {
	return defaultFetch<AssetType[]>(`/v0/projects/${projectId}/projectassets`);
};
